// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mo-1";
export var stateContainer = "_mo-0";